module.exports = __webpack_public_path__ + "static/media/src-design03.37ebd270.png";